import useTitle from "../Hooks/useTitle";
import { useTranslation } from "react-i18next";

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();

  useTitle(`${t("privacy-policy.privacy-policy")} | Netileti`);

  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center",textAlign:"left" }}
    >
      <div
        className="control-wrapper"
        style={{
          flexDirection: "column",
          alignItems: "baseline",
          height: "100%",
          padding: "20px",
        }}
      >
        <h1>{t("privacy-policy.privacy-policy")}</h1>
        <p>{t("privacy-policy.effective-date")}</p>
        <p>{t("privacy-policy.app-name")}</p>
        <p>{t("privacy-policy.company")}</p>

        <h2>{t("privacy-policy.section1-title")}</h2>
        <p>{t("privacy-policy.section1-content")}</p>
        <ul>
          <li>{t("privacy-policy.section1-items.personal")}</li>
          <li>{t("privacy-policy.section1-items.usage")}</li>
          <li>{t("privacy-policy.section1-items.waba")}</li>
          <li>{t("privacy-policy.section1-items.communication")}</li>
        </ul>

        <h2>{t("privacy-policy.section2-title")}</h2>
        <ul>
          <li>{t("privacy-policy.section2-items.provide")}</li>
          <li>{t("privacy-policy.section2-items.manage")}</li>
          <li>{t("privacy-policy.section2-items.automated")}</li>
          <li>{t("privacy-policy.section2-items.support")}</li>
        </ul>

        <h2>{t("privacy-policy.section3-title")}</h2>
        <p>{t("privacy-policy.section3-content")}</p>
        <ul>
          <li>{t("privacy-policy.section3-items.meta")}</li>
          <li>{t("privacy-policy.section3-items.providers")}</li>
          <li>{t("privacy-policy.section3-items.legal")}</li>
        </ul>

        <h2>{t("privacy-policy.section4-title")}</h2>
        <p>{t("privacy-policy.section4-content")}</p>

        <h2>{t("privacy-policy.section5-title")}</h2>
        <p>{t("privacy-policy.section5-intro")}</p>
        <ul>
          <li>{t("privacy-policy.section5-items.access")}</li>
          <li>{t("privacy-policy.section5-items.withdraw")}</li>
        </ul>
        <p>{t("privacy-policy.section5-end")}</p>

        <h2>{t("privacy-policy.section6-title")}</h2>
        <p>{t("privacy-policy.section6-content")}</p>

        <h2>{t("privacy-policy.section7-title")}</h2>
        <p>{t("privacy-policy.section7-content")}</p>

        <h2>{t("privacy-policy.section8-title")}</h2>
        <p>{t("privacy-policy.section8-content")}</p>

        <h2>{t("privacy-policy.section9-title")}</h2>
        <p>{t("privacy-policy.section9-content")}</p>
        <ul>
          <li>{t("privacy-policy.contact.company")}</li>
          <li>{t("privacy-policy.contact.email")}</li>
          <li>{t("privacy-policy.contact.address")}</li>
          <li>{t("privacy-policy.contact.website")}</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
